<template>
	<DashboardComponent 
		:chartsGroups="chartsGroups"
		/>
</template>

<script>
import DashboardComponent from '@vueapp/components/DashboardComponent.vue'

export default {
	components: {
		DashboardComponent
	},
	data() {
		return {
			templateData: {},
		}
	},
	props: {
		postSlug: String,
		postId: String
	},
	methods: {

	},
	computed: {
		chartsGroups() {
			return this.templateData.charts_groups ?? []
		},
	},
	async beforeCreate() {

		const params = new URLSearchParams(window.location.search),
            eParams = {}

        params.forEach((value, name) => {
            if ( ! name.match(/env|debug/) && value.match(/^([a-z0-9\_\-\+\ ]+)$/) ) {
                eParams[name] = value
            }
        })
        const paramsString = ( new URLSearchParams(eParams) ) .toString()
        
		fetch( BRYTER.homeUrl + '/dashboard/' + this.postSlug + '/?env=' + BRYTER.envId + '&json&t=' + Date.now() + '&' + paramsString)
      		.then(response => response.json())
      		.then(data => {
        		this.templateData = data
        		// this.loading = false
      		})
	}
}
</script>